var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
export {
  SPACE_SEPARATOR_REGEX
};
//# sourceMappingURL=regex.generated.js.map
